import {getCookie} from "@js/globalFunctions/cookieHandling";

let hasAddedLivechat = false;
export function initLiveChat()
{
	if( checkIfMayAddLiveChat() )
	{
		$('body').append('' +
			'<!-- Start of LiveChat (www.livechatinc.com) code -->\n' +
			'<script type="text/javascript">\n' +
			'window.__lc = window.__lc || {};\n' +
			'window.__lc.license = 8542401;\n' +
			'(function() {\n' +
			'  var lc = document.createElement(\'script\'); lc.type = \'text/javascript\'; lc.async = true;\n' +
			'  lc.src = (\'https:\' == document.location.protocol ? \'https://\' : \'http://\') + \'cdn.livechatinc.com/tracking.js\';\n' +
			'  var s = document.getElementsByTagName(\'script\')[0]; s.parentNode.insertBefore(lc, s);\n' +
			'})();\n' +
			'</script>\n' +
			'<!-- End of LiveChat code -->'
		)
		hasAddedLivechat = true;
	}
}

function checkIfMayAddLiveChat()
{
	const cookieNoticeVal = getCookie('cookie_notice_accepted');
	return ( typeof cookieNoticeVal !== 'undefined' && cookieNoticeVal === 'true' && hasAddedLivechat === false);
}
